import { render, staticRenderFns } from "./addQuestion.vue?vue&type=template&id=4504265c&scoped=true&"
import script from "./addQuestion.vue?vue&type=script&lang=js&"
export * from "./addQuestion.vue?vue&type=script&lang=js&"
import style0 from "./addQuestion.vue?vue&type=style&index=0&id=4504265c&prod&lang=less&scoped=true&"
import style1 from "./addQuestion.vue?vue&type=style&index=1&id=4504265c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4504265c",
  null
  
)

export default component.exports